import React, { FC } from 'react'
import { injectIntl } from 'react-intl'

interface OrLabelProps {
  className?: string
  intl: { formatMessage(params: Record<string, string>): string }
}

const OrLabel: FC<OrLabelProps> = ({ className, intl }: OrLabelProps) => {
  return (
    <div
      className={`relative flex justify-center lh-solid bt b--muted-4 ${className}`}
    >
      <span className="inline-flex justify-center items-center c-muted-1 bg-white w2 absolute translate-to-top-50 nt1">
        {intl.formatMessage({ id: 'orLabel' })}
      </span>
    </div>
  )
}

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
export default injectIntl(OrLabel)
